import { Channel } from '@flowus/common/block/channel';
import { Tooltip } from '@flowus/common/components/tooltip';
import { useOpenModal } from '@flowus/common/next-modal';
import type { FC, MouseEvent } from 'react';
import { useEffect } from 'react';
import { Icon } from 'src/common/components/icon';
import { SPECIAL_SPACE_ID } from 'src/common/const';
import { MessagePanel } from '../message-panel';
import { useRefreshUnreadState, useUnreadState } from '../message-panel/shared';

export const SubscribeNotification: FC = () => {
  const openModal = useOpenModal();
  const refreshUnreadState = useRefreshUnreadState();
  const unreadState = useUnreadState();

  const handleClick = (event: MouseEvent) => {
    openModal.dropdown({
      popcorn: event.currentTarget,
      content: () => <MessagePanel channels={[Channel.SUBSCRIBE]} />,
    });
  };

  useEffect(() => {
    void refreshUnreadState();
  }, [refreshUnreadState]);

  const count = unreadState[SPECIAL_SPACE_ID]?.subscribe;

  return (
    <Tooltip
      popup={'查看订阅消息'}
      placement="bottom"
      onClick={handleClick}
      className={'relative flex items-center p-1 justify-center animate-hover message-panel'}
    >
      <Icon name={'IcMessage'} size="middle" />
      <span
        hidden={!count}
        className="absolute top-0 right-0 min-w-[20px] h-[18px] px-0.5 inline-flex items-center justify-center text-white bg-red text-t4-medium ml-auto rounded-full"
      >
        {count}
      </span>
    </Tooltip>
  );
};
